import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { ref, getDownloadURL } from "firebase/storage";
import { doc as firestoreDoc, updateDoc } from "firebase/firestore";
import { db, storage } from "../Firebase";

export const createLetters = async (template, selectedProperties) => {
  if (selectedProperties.length === 0) {
    alert("No properties selected for letter generation.");
    return;
  }
  if (!template) {
    alert("No template selected.");
    return;
  }

  try {
    const templateRef = ref(storage, `templates/${template.name}`);
    const url = await getDownloadURL(templateRef);
    const response = await fetch(url);
    const content = await response.arrayBuffer();

    if (selectedProperties.length === 1) {
      const property = selectedProperties[0];
      await generateSingleLetter(content, property);
    } else {
      await generateMultipleLetters(content, selectedProperties);
    }
  } catch (error) {
    console.error("Error fetching template:", error);
    alert("Failed to generate letters. Please try again.");
  }
};

const generateLetterBlob = async (content, property) => {
  const zip = new PizZip(content);
  const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true,
  });

  const todayDate = new Date().toLocaleDateString("en-GB");

  const dynamicData = {
    houseNumber: property.houseNumber || "N/A",
    roadName: property.roadName || "N/A",
    town: property.town || "N/A",
    county: property.county || "N/A",
    postcode: property.postcode || "N/A",
    weeksOnMarket:
      property.weeksOnMarket !== undefined ? property.weeksOnMarket : "N/A",
    agent: property.agent || "N/A",
    todaysDate: todayDate,
  };

  doc.setData(dynamicData);

  try {
    doc.render();
  } catch (error) {
    console.error("Error rendering document:", error);
    throw error;
  }

  const out = doc.getZip().generate({
    type: "blob",
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });

  const propertyRef = firestoreDoc(db, "properties", property.id);
  await updateDoc(propertyRef, {
    lastLetterDate: todayDate,
  });

  return out;
};

const generateSingleLetter = async (content, property) => {
  const letterBlob = await generateLetterBlob(content, property);
  saveAs(letterBlob, `${property.roadName}-${property.houseNumber}.docx`);
};

const generateMultipleLetters = async (content, properties) => {
  const jszip = new JSZip();

  for (const property of properties) {
    const letterBlob = await generateLetterBlob(content, property);
    jszip.file(`${property.roadName}-${property.houseNumber}.docx`, letterBlob);
  }

  const zipBlob = await jszip.generateAsync({ type: "blob" });
  saveAs(zipBlob, "letters.zip");
};

export { generateSingleLetter, generateLetterBlob };
